import { render } from "./Result.vue?vue&type=template&id=0e417096"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=0e417096&lang=less"
script.render = render

export default script